module.exports = __webpack_public_path__ + "media/map/marker-shadow-064d819b.png";